import { InheritanceStatus, QuestInterface } from "@swivl-mono/types";

import { Member } from "../../Models/Member/Member.Current";
import "./InheritanceTag.scss";

interface NavBarInheritanceTagProps {
  quest?: QuestInterface;
  inheritance?: InheritanceStatus;
  showParent?: boolean;
}
export const InheritanceTag: React.FC<any> = (props: NavBarInheritanceTagProps) => {
  const { quest, inheritance } = props as NavBarInheritanceTagProps;
  let theInheritance = inheritance;
  if (quest && quest.inheritance) {
    theInheritance = quest.inheritance;
  }

  if (Member.isInChildOrg) {
    if (theInheritance === InheritanceStatus.IS_CHILD) {
      return <div className="InheritanceTag child select-none">CHILD</div>;
    }
    if (theInheritance === InheritanceStatus.NONE) {
      return <div className="InheritanceTag standalone select-none">STANDALONE</div>;
    }
    return <div className="InheritanceTag parent select-none">PARENT</div>;
  }

  return <></>;
};
